module.exports = __webpack_public_path__ + "img/case4.49d8d056.png";